export default function PrivacyPolicy() {
  return (
    <section id="privacy" className="py-32 bg-[#F8F9FA]">
      <div className="max-w-5xl mx-auto px-8">
        <h2 className="text-5xl font-bold text-[#1A2B4A] mb-6" style={{ fontFamily: 'Georgia, serif' }}>
          Privacy Policy
        </h2>
        <p className="text-lg text-[#4A4A4A] mb-12">
          Last updated: January 2025
        </p>

        <div className="space-y-10 text-[#4A4A4A] leading-relaxed">
          <div>
            <h3 className="text-2xl font-bold text-[#1A2B4A] mb-4">Our Commitment to Privacy</h3>
            <p>
              At SERGAS S.R.L., we are deeply committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data when you use our VPN services.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#1A2B4A] mb-4">No-Logs Policy</h3>
            <p>
              We maintain a strict no-logs policy. We do not track, collect, or store any information about your online activities, including:
            </p>
            <ul className="list-disc list-inside mt-4 space-y-2 ml-4">
              <li>Browsing history or websites visited</li>
              <li>Connection timestamps or session duration</li>
              <li>IP addresses or DNS queries</li>
              <li>Bandwidth usage or traffic data</li>
              <li>Downloaded files or content accessed</li>
            </ul>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#1A2B4A] mb-4">Information We Collect</h3>
            <p>
              To provide our VPN service, we only collect minimal information necessary for account management:
            </p>
            <ul className="list-disc list-inside mt-4 space-y-2 ml-4">
              <li>Email address for account creation and communication</li>
              <li>Payment information (processed securely through third-party payment processors)</li>
              <li>Technical support inquiries and correspondence</li>
            </ul>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#1A2B4A] mb-4">Data Security</h3>
            <p>
              We employ industry-leading security measures to protect your data, including AES-256 encryption, secure server infrastructure, and regular security audits. All data transmission between your device and our servers is encrypted and protected against unauthorized access.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#1A2B4A] mb-4">Third-Party Services</h3>
            <p>
              We do not sell, trade, or share your personal information with third parties for marketing purposes. Payment processing is handled by trusted third-party payment processors who maintain their own privacy policies and security standards.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#1A2B4A] mb-4">Data Retention</h3>
            <p>
              We retain your account information only for as long as your account remains active. Upon account deletion, all associated personal information is permanently removed from our systems within 30 days.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#1A2B4A] mb-4">Your Rights</h3>
            <p>
              You have the right to access, modify, or delete your personal information at any time. You may also request a copy of the data we hold about you. To exercise these rights, please contact us at info@sergassrl.com.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#1A2B4A] mb-4">Cookies and Tracking</h3>
            <p>
              Our website uses minimal cookies necessary for basic functionality. We do not use tracking cookies or third-party analytics tools that could compromise your privacy.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#1A2B4A] mb-4">Changes to This Policy</h3>
            <p>
              We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify users of any significant changes via email or through our website.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#1A2B4A] mb-4">Contact Us</h3>
            <p>
              If you have any questions or concerns about our Privacy Policy or data practices, please contact us:
            </p>
            <div className="mt-4 space-y-2">
              <p><strong>Email:</strong> info@sergassrl.com</p>
              <p><strong>Phone:</strong> +1 775 402 8843</p>
              <p><strong>Address:</strong> Vicalte Eduardo O'Connor 665, San Carlos de Bariloche, R8400ACI, Argentina</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
